import TemplateView from '../../../../../TemplateView'
import {Product} from '../../../../../constants'
import messageResource from '../../../../../messageResource'
import {connect} from '../../../../../redux/utils'
import {getPrice, getUsersCount, isSelectUnlimitedUsers} from './selectors'
import {calculatePrice, calculatePriceForUnlimited, setUsersCount} from './actions'
import {bindActionCreators} from 'redux'
import {isInt} from '../../../../../atUtils'
import {MIN_USERS_COUNT_FOR_ADD_USERS, PricingModelType, USERS_LIMITED_PACKAGES} from '../../../constants'
import Button from '../../../../../components/Button'
import {DateFormat} from '../../../../../date_format'
import {getMaxUsersToUnlimited, getPricingModelType} from '../../../selectors'
import NumberFormatter from '../../../../../number_formatter'
import SimpleListMenuButton from '../../../../../SimpleListMenuButton'

class AddUsersCard extends TemplateView {
    constructor({
        active,
        trial,
        expired,
        startDate,
        expirationDate,
        daysToExpiration,
        issueDate,
        unlimited,
        allowedUsersCount,
        free,
        currentUsersCount,
        formattedName,
        licensesMonthCount,
        product,
        licenseId,
        calculatePrice = () => {},
        setUsersCount = () => {},
        calculatePriceForUnlimited = () => {},
        onCancelButtonClick = () => {},
        onPurchaseClick = () => {},
    }) {
        super()

        this.params = {
            active,
            trial,
            startDate,
            expired,
            expirationDate,
            daysToExpiration,
            issueDate,
            unlimited,
            allowedUsersCount,
            free,
            currentUsersCount,
            formattedName,
            licensesMonthCount,
            product,
            licenseId,
        }

        this.callback = {
            onCancelButtonClick,
        }

        this.actions = {
            calculatePrice,
            calculatePriceForUnlimited,
            onPurchaseClick,
            setUsersCount,
        }

        this.state = {
            pricingModelType: PricingModelType.USER,
            price: 0,
            currentUsersCountSelected: 0,
            isUnlimitedSelected: false,
            maxUsersToUnlimited: 0,
        }

        this.dateFormat = new DateFormat(window.SystemSettings.dateFormat)

        this.onStatePropertyChanged('price', (price) => {
            this.$price.text(messageResource.getMessage('licenses.price', [this.numberFormatter.format(price / 100)]))
        })

        this.onStatePropertyChanged('isUnlimitedSelected', (isUnlimitedSelected) => {
            this.$addInputs.toggle(!isUnlimitedSelected)
            this.$unlimitedNote.toggle(isUnlimitedSelected)

            if (isUnlimitedSelected) {
                this.$switchToUnlimitedButton.text(messageResource.getMessage('licenses.pay_per_user'))
            } else {
                this.$switchToUnlimitedButton.text(messageResource.getMessage('licenses.switch_to_unlimited'))
            }
        })

        this.onAnyStatePropertyChanged(['maxUsersToUnlimited', 'currentUsersCountSelected', 'isUnlimitedSelected', 'pricingModelType'], () => {
            this.$totalUsersMessage.text(messageResource.getMessage('licenses.add_users_card.total_users_message',
                [this.state.currentUsersCountSelected + this.params.allowedUsersCount]))
            this.$usersToAddMessage.text(messageResource.getMessage('licenses.add_users_card.users_to_add_message',
                [this.state.currentUsersCountSelected]))

            this.$additionalUsers.val(this.state.currentUsersCountSelected)
            this.usersCountByPackage.setSelectedItem(this.params.allowedUsersCount + this.state.currentUsersCountSelected)

            const disablePurchase = !this.state.isUnlimitedSelected &&
                                    this.state.currentUsersCountSelected + this.params.allowedUsersCount > this.state.maxUsersToUnlimited
            this.$error.toggle(disablePurchase)
            this.$price.toggle(!disablePurchase)
            this.purchaseButton.setState({disabled: disablePurchase})

            const licenseAlreadyMaxedOut = this.params.allowedUsersCount >= this.state.maxUsersToUnlimited
            this.$switchToUnlimitedButton.toggle(!licenseAlreadyMaxedOut)
            this.$separator.toggle(!licenseAlreadyMaxedOut)
        })

        this.onStatePropertyChanged('maxUsersToUnlimited', (maxUsersToUnlimited) => {
            this.$error.text(messageResource.getMessage('licenses.unlimited_error', [maxUsersToUnlimited]))
        })

        this.onStatePropertyChanged('pricingModelType', (pricingModelType) => {
            this.$titleByUser.toggle(pricingModelType === PricingModelType.USER)
            this.$additionalUsers.toggle(pricingModelType === PricingModelType.USER)
            this.$totalUsersMessage.toggle(pricingModelType === PricingModelType.USER)

            this.$titleByPackage.toggle(pricingModelType === PricingModelType.PACKAGE)
            this.usersCountByPackage.toggle(pricingModelType === PricingModelType.PACKAGE)
            this.$usersToAddMessage.toggle(pricingModelType === PricingModelType.PACKAGE)
        })
    }

    templateHtml() {
        return '<div class="licenseCard addUsersCard">' +
               '    <div class="headerCard">' +
               '        <div class="img"/>' +
               '        <div class="licensesTitle">' +
               '            <div class="text"><%=cardTitle%></div>' +
               '        </div>' +
               '        <div class="cancelButton"><%=cancelButtonMessage%></div>' +
               '    </div>' +
               '    <div class="licensesInfo">' +
               '        <div class="usersSection">' +
               '            <div class="currentlyLicensedTitle"><%=currentlyLicensedTitle%></div>' +
               '            <div class="currentlyLicensedCounts"><%=currentlyLicensedCounts%></div>' +
               '        </div>' +
               '        <div class="usersAddSection">' +
               '            <div class="title byUser"><%=usersToAddTitle%></div>' +
               '            <div class="title byPackage"><%=setUsersCountTitle%></div>' +
               '            <div class="addInputs">' +
               '                <input type="text" class="additionalUsers" maxlength="6">' +
               '                <div class="usersCountByPackage"/>' +
               '                <div class="totalUsersMessage"/>' +
               '                <div class="usersToAddMessage"/>' +
               '            </div>' +
               '            <div class="unlimitedNote"><%=unlimitedNote%></div>' +
               '            <div class="separator"/>' +
               '            <div class="switchToUnlimitedButton"/>' +
               '        </div>' +
               '    </div>' +
               '    <div class="footerCard">' +
               '        <div class="error"/>' +
               '        <div class="price"/>' +
               '        <div class="purchaseButton"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            cancelButtonMessage: 'common.cancel',
            unlimitedNote: 'licenses.switch_to_unlimited',
            usersToAddTitle: 'licenses.add_users_card.users_to_add',
            setUsersCountTitle: 'licenses.add_users_card.set_users_count',
            currentlyLicensedTitle: 'licenses.add_users_card.currently_licensed_title',
        }
    }

    templateModel() {
        return {
            cardTitle: messageResource.getMessage('licenses.add_users_card.title',
                [this.dateFormat.formatDate(this.params.startDate), this.dateFormat.formatDate(this.params.expirationDate)]),
            currentlyLicensedCounts: messageResource.getMessage('licenses.add_users_card.currently_licensed_counts',
                [this.params.allowedUsersCount, this.params.currentUsersCount])
        }
    }

    afterRender() {
        this.find('.cancelButton').click(this.callback.onCancelButtonClick)

        this.$productLogo = this.find('.img')
        this.$productLogo.toggleClass('at', this.params.product === Product.actiTIME)
        this.$productLogo.toggleClass('ap', this.params.product === Product.actiPLANS)

        this.$titleByUser = this.find('.title.byUser')
        this.$titleByPackage = this.find('.title.byPackage')
        this.$price = this.find('.price')
        this.$addInputs = this.find('.addInputs')
        this.$totalUsersMessage = this.find('.totalUsersMessage')
        this.$usersToAddMessage = this.find('.usersToAddMessage')
        this.$unlimitedNote = this.find('.unlimitedNote')
        this.$separator = this.find('.separator')
        this.$switchToUnlimitedButton = this.find('.switchToUnlimitedButton')
        this.$error = this.find('.error')

        this.$switchToUnlimitedButton.click(() => {
            const newUnlimited = !this.state.isUnlimitedSelected
            if (newUnlimited) {
                this.actions.calculatePriceForUnlimited(this.params.licenseId)
            } else {
                this.actions.calculatePrice(this.params.licenseId, this.state.currentUsersCountSelected)
            }
        })

        this.$additionalUsers = this.find('.additionalUsers')

        this.$additionalUsers.val(MIN_USERS_COUNT_FOR_ADD_USERS)

        this.$additionalUsers.on('change', () => {
            let value = this.$additionalUsers.val()

            if (isInt(value) && parseInt(value) >= MIN_USERS_COUNT_FOR_ADD_USERS) {
                const currentUserCount = parseInt(value)

                if (currentUserCount + this.params.allowedUsersCount <= this.state.maxUsersToUnlimited) {
                    this.actions.calculatePrice(this.params.licenseId, currentUserCount)
                } else {
                    this.actions.setUsersCount(currentUserCount)
                }
            } else {
                this.$additionalUsers.val(this.state.currentUsersCountSelected)
            }
        })

        this.usersCountByPackage = new SimpleListMenuButton({
            itemHtmlCallback: item => item,
            onSelect: item => this.actions.calculatePrice(this.params.licenseId, item - this.params.allowedUsersCount),
            itemHeight: 30,
        }).init(this.find('.usersCountByPackage'))
        this.usersCountByPackage.setItems(USERS_LIMITED_PACKAGES.filter(p => p > this.params.allowedUsersCount))

        this.purchaseButton = new Button({
            additionalClass: 'purchase',
            label: messageResource.getMessage('licenses.purchase'),
            onClickCb: () => this.actions.onPurchaseClick()
        }).init(this.find('.purchaseButton'))

        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)
    }
}

export default connect(
    (state) => ({
        pricingModelType: getPricingModelType(state),
        price: getPrice(state),
        currentUsersCountSelected: getUsersCount(state),
        isUnlimitedSelected: isSelectUnlimitedUsers(state),
        maxUsersToUnlimited: getMaxUsersToUnlimited(state),
    }),
    (dispatch) => ({
        calculatePrice: bindActionCreators(calculatePrice, dispatch),
        setUsersCount: bindActionCreators(setUsersCount, dispatch),
        calculatePriceForUnlimited: bindActionCreators(calculatePriceForUnlimited, dispatch),
    })
)(AddUsersCard)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/addUsers/AddUsersCard.js